import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo">BricksNHome</div>
          <p className="footer-tagline">Greater Noida's Most Trusted Real Estate Partner.<br />Your Dream. Your Paradise.</p>
          <div className="footer-cert">
            <span>🏆 RERA Registered</span>
            <span>✅ Paradise Group NCR</span>
          </div>
          <div className="social-icons">
            <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer"><i className="fab fa-instagram" /></a>
            <a href="https://twitter.com" aria-label="Twitter" target="_blank" rel="noreferrer"><i className="fab fa-twitter" /></a>
            <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f" /></a>
            <a href="https://linkedin.com" aria-label="LinkedIn" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in" /></a>
            <a href={`https://wa.me/917477471006`} aria-label="WhatsApp" target="_blank" rel="noreferrer"><i className="fab fa-whatsapp" /></a>
          </div>
        </div>

        {/* Properties */}
        <div className="footer-links">
          <h4>Our Projects</h4>
          <ul>
            <li><a href="#listings">Krishna Vatika – 4BHK Villas</a></li>
            <li><a href="#listings">Lotus Greens Villa 2 – 3&4 BHK</a></li>
            <li><a href="#listings">Aalayam Srishti Villas</a></li>
            <li><a href="#listings">Bollywood Aero City Farms</a></li>
            <li><a href="#listings">Paradise Greens Plaza</a></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-links">
          <h4>Our Services</h4>
          <ul>
            <li><a href="#listings">Buy Property</a></li>
            <li><a href="#listings">Sell Property</a></li>
            <li><a href="#listings">Rent / Lease</a></li>
            <li><a href="#listings">Investment Advisory</a></li>
            <li><a href="#listings">Home Loan Assistance</a></li>
            <li><a href="#listings">Legal & Registration</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-links">
          <h4>Contact Us</h4>
          <ul>
            <li>
              <i className="fa fa-phone" />
              <a href="tel:+917477471006">+91 7477-471-006</a>
            </li>
            <li>
              <i className="fa fa-envelope" />
              <a href="mailto:info@bricksnhome.com">info@bricksnhome.com</a>
            </li>
            <li>
              <i className="fab fa-whatsapp" />
              <a href="https://wa.me/917477471006" target="_blank" rel="noreferrer">WhatsApp Us</a>
            </li>
            <li>
              <i className="fa fa-location-dot" />
              <span>Sec 16, Chipyana Bujurg,<br />Greater Noida West – 201009</span>
            </li>
            <li>
              <i className="fa fa-clock" />
              <span>Mon – Sat: 9 AM – 7 PM</span>
            </li>
          </ul>
        </div>

      </div>

      {/* Greater Noida Belt highlights */}
      <div className="footer-belt">
        <div className="footer-belt-inner">
          <span>📍 Greater Noida West</span>
          <span>✈️ Near Jewar Airport</span>
          <span>🎬 Near YEIDA Film City</span>
          <span>🏏 Near Buddh International Circuit</span>
          <span>🚇 Metro Connectivity</span>
          <span>🏫 Top Schools in 1 Km</span>
          <span>🏥 Super Specialty Hospitals</span>
          <span>🛍️ Gaur City Mall – 4 Km</span>
        </div>
      </div>

      <div className="footer-bottom">
        <span>&copy; 2026 BricksNHome · Paradise Group NCR. All rights reserved.</span>
        <span className="footer-bottom-right">
          Designed for Greater Noida's finest real estate.
        </span>
      </div>
    </footer>
  );
}
